import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Navigation,
  Footer,
  Home,
  Nftmarketplace,
  Cryptodevelopment,
  Cryptoexchange,
  Contact,
} from "./components";
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <Router>
    <Navigation />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/nftmarketplace" element={<Nftmarketplace />} />
      <Route path="/cryptoexchange" element={<Cryptoexchange />} />
      <Route path="/cryptodevelopment" element={<Cryptodevelopment />} />
    </Routes>
    <Footer />
  </Router>,

  document.getElementById("root")
);

